import React from "react";
import { Drawer } from "antd";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import Footer from "./Footer";
import RenderBody from "./RenderBody";

const RentalDetailsDrawer = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  return (
    <Drawer
      width={560}
      placement="right"
      closable={false}
      maskStyle={{
        background: "transparent",
        boxShadow: "12px 12px 16px -4px #10182814",
      }}
      open={visible}
      onClose={onCancel}
      className="rounded-tl-xl"
    >
      <div className="flex flex-col h-full">
        <div className="w-full p-6 bg-background-white flex items-center justify-between rounded-tl-xl">
          <p className="font-poppins font-medium text-base text-black">
            Request Details
          </p>

          <CloseIcon
            className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
            onClick={onCancel}
          />
        </div>

        <RenderBody onCancel={onCancel} />

        <Footer
          onCancel={onCancel}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </Drawer>
  );
};

export default RentalDetailsDrawer;
